import {
  text_children,
  bs_text_children,
  app_text_children,
  app_detail_prev_children,
  app_detail_next_children,
  detail_next_children,
  detail_prev_children
} from "./menus/index"
import { getOptDes } from "./menus/optDes"
import render from "./render/index.vue"
const cxText = {
  name: "cxText",
  desc: "基础文本样式",
  render: render,
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "文本",
        group: "baseElement",
        children: app_text_children,
        sort: 1
      },
      {
        name: "上一篇",
        group: "baseElement",
        children: app_detail_prev_children,
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 3
      },
      {
        name: "下一篇",
        group: "baseElement",
        children: app_detail_next_children,
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 4
      }
    ],
    bigScreen: [
      {
        name: "文本",
        children: bs_text_children,
        group: "element",
        sort: 20
      }
    ],
    portal: [
      {
        name: "文本",
        children: text_children,
        group: "baseElement",
        sort: 1
      },
      {
        name: "上一篇",
        group: "baseElement",
        children: detail_prev_children,
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 3
      },
      {
        name: "下一篇",
        group: "baseElement",
        children: detail_next_children,
        enable(params) {
          let detailPageBusinessFlag = true
          if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 4
      }
    ]
  },
  toolbars: [
    {
      name: "cxText",
      label: "文本",
      comp: {
        textComponentData: () => import("./toolbars/text-options-data.vue"),
        textComponentSetting: () => import("./toolbars/text-options-setting.vue"),
        textComponentStyle: () => import("./toolbars/text-options-style.vue")
      }
    }
  ]
}

export default cxText
